(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plantalea-launch-header"]) return;
  try {
    
function plantaleaScrollNavigation(root = document) {
  root.querySelectorAll('.pl-header-scroll-slot').forEach(slot => {
    if (slot.dataset.scrollReady) return;
    slot.dataset.scrollReady = 'true';
    const header = slot.querySelector('.pl-header');
    const menu = header.querySelector('.pl-mobile-menu');
    const controller = new AbortController();
    let scroller;
    const findScroller = () => {
      scroller = slot.parentElement;
      while (scroller && !/(auto|scroll)/.test(getComputedStyle(scroller).overflowY)) {
        scroller = scroller.parentElement;
      }
    };
    findScroller();
    const scrollY = () => scroller ? scroller.scrollTop : window.scrollY;
    let previousY = scrollY();
    let boundary = 0;
    let frame = 0;
    const measure = () => {
      findScroller();
      const height = header.getBoundingClientRect().height;
      slot.style.height = height + 'px';
      boundary = slot.getBoundingClientRect().top - (scroller ? scroller.getBoundingClientRect().top : 0) + scrollY() + height;
    };
    const show = () => {
      header.classList.remove('is-scroll-hidden');
      header.inert = false;
    };
    const update = () => {
      frame = 0;
      const y = Math.max(0, scrollY());
      if (y <= boundary) {
        header.classList.remove('is-scroll-floating', 'is-scroll-hidden');
        header.inert = false;
        previousY = y;
        return;
      }
      header.classList.add('is-scroll-floating');
      if (menu.open || header.contains(document.activeElement)) {
        show();
        previousY = y;
      } else if (Math.abs(y - previousY) >= 6) {
        const hide = y > previousY;
        header.classList.toggle('is-scroll-hidden', hide);
        header.inert = hide;
        previousY = y;
      }
    };
    const onScroll = () => { if (!frame) frame = requestAnimationFrame(update); };
    const observer = new ResizeObserver(measure);
    observer.observe(header);
    measure();
    update();
    window.addEventListener('scroll', onScroll, { passive: true, capture: true, signal: controller.signal });
    window.addEventListener('resize', () => { measure(); update(); }, { signal: controller.signal });
    header.addEventListener('focusin', show, { signal: controller.signal });
    menu.addEventListener('toggle', () => { if (menu.open) show(); }, { signal: controller.signal });
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(slot)) {
        controller.abort();
        observer.disconnect();
        cancelAnimationFrame(frame);
      }
    }, { signal: controller.signal });
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => plantaleaScrollNavigation(), { once: true });
} else {
  plantaleaScrollNavigation();
}
document.addEventListener('shopify:section:load', event => plantaleaScrollNavigation(event.target));

  } catch(e) { console.error(e); }
})();
})();
